import { Helmet } from 'react-helmet-async';

const SITE_NAME = "Entrepôt Auto Montréal";
const BASE_URL = "https://entrepotautomontreal.ca";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;
const PHONE = "+1-833-995-6477";
const ADDRESS = "1007 boul. René-Lévesque, Verdun, QC H3E 1H5";
const GOOGLE_MAPS_EMBED = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2797.5!2d-73.5712!3d45.4631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sEntrepot%20Auto%20Montreal!5e0!3m2!1sfr!2sca!4v1";

// Enhanced Business Schema for LocalBusiness/AutoDealer with more local signals
const businessSchema = {
  "@context": "https://schema.org",
  "@type": ["AutoDealer", "LocalBusiness", "Store"],
  "@id": `${BASE_URL}/#organization`,
  "name": "Entrepôt Auto Montréal",
  "alternateName": ["Entrepot Auto Montreal", "Entrepôt Auto", "EAM", "Entrepot Auto Verdun"],
  "url": BASE_URL,
  "logo": {
    "@type": "ImageObject",
    "url": `${BASE_URL}/logo512.png`,
    "width": 512,
    "height": 512
  },
  "image": [
    `${BASE_URL}/logo512.png`,
    `${BASE_URL}/storefront.jpg`
  ],
  "description": "Concessionnaire de véhicules d'occasion de qualité à Verdun, Montréal. Financement 1re, 2e et 3e chance au crédit avec 99% d'approbations. Large sélection de voitures, VUS et camions certifiés.",
  "slogan": "Redéfinir L'expérience Automobile",
  "telephone": PHONE,
  "email": "info@entrepotautomontreal.ca",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "1007 boul. René-Lévesque",
    "addressLocality": "Verdun",
    "addressRegion": "QC",
    "postalCode": "H3E 1H5",
    "addressCountry": "CA"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 45.4631,
    "longitude": -73.5712
  },
  "hasMap": "https://maps.google.com/?q=Entrepot+Auto+Montreal+Verdun",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "18:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "10:00",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Sunday",
      "opens": "00:00",
      "closes": "00:00"
    }
  ],
  "priceRange": "$$",
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card", "Financing", "Interac"],
  "currenciesAccepted": "CAD",
  "areaServed": [
    {
      "@type": "City",
      "name": "Montréal",
      "sameAs": "https://en.wikipedia.org/wiki/Montreal"
    },
    {
      "@type": "City",
      "name": "Verdun",
      "containedIn": "Montréal"
    },
    {
      "@type": "City",
      "name": "Laval"
    },
    {
      "@type": "City", 
      "name": "Longueuil"
    },
    {
      "@type": "City",
      "name": "Brossard"
    },
    {
      "@type": "City",
      "name": "Saint-Laurent"
    },
    {
      "@type": "City",
      "name": "LaSalle"
    },
    {
      "@type": "City",
      "name": "Lachine"
    },
    {
      "@type": "City",
      "name": "Pointe-Claire"
    },
    {
      "@type": "City",
      "name": "Dorval"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Rive-Sud de Montréal"
    },
    {
      "@type": "AdministrativeArea",
      "name": "West Island"
    },
    {
      "@type": "AdministrativeArea",
      "name": "Québec"
    }
  ],
  "sameAs": [
    "https://www.facebook.com/EntrepotAutoMontreal",
    "https://www.instagram.com/entrepotautomontreal"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "187",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": [
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Alexandre Dubois"
      },
      "datePublished": "2025-11-20",
      "reviewBody": "Le meilleur concessionnaire de véhicules d'occasion à Montréal! Service impeccable, prix honnêtes et financement rapide même avec un crédit imparfait. J'ai trouvé mon Toyota RAV4 en parfait état."
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Marie-Claude Bergeron"
      },
      "datePublished": "2025-10-15",
      "reviewBody": "Expérience exceptionnelle du début à la fin. L'équipe a pris le temps de comprendre mes besoins et mon budget. Mon Hyundai Tucson est exactement ce que je cherchais. Merci!"
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Karim Hassani"
      },
      "datePublished": "2025-09-28",
      "reviewBody": "Après plusieurs refus ailleurs, Entrepôt Auto m'a approuvé pour un financement 3e chance. Véhicule de qualité et service professionnel. Je recommande à tous ceux qui ont des difficultés de crédit."
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Véhicules d'occasion",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "Voitures",
        "description": "Berlines, coupés et compactes d'occasion"
      },
      {
        "@type": "OfferCatalog",
        "name": "VUS et Crossovers",
        "description": "VUS et multisegments d'occasion"
      },
      {
        "@type": "OfferCatalog",
        "name": "Camions",
        "description": "Camionnettes d'occasion"
      }
    ]
  },
  "potentialAction": [
    {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${BASE_URL}/inventory?search={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    },
    {
      "@type": "ReserveAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${BASE_URL}/contact`
      },
      "name": "Réserver un essai routier"
    }
  ]
};

// Website Schema for Sitelinks Search Box
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${BASE_URL}/#website`,
  "url": BASE_URL,
  "name": SITE_NAME,
  "description": "Concessionnaire de véhicules d'occasion de qualité à Montréal",
  "publisher": {
    "@id": `${BASE_URL}/#organization`
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${BASE_URL}/inventory?search={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  },
  "inLanguage": "fr-CA"
};

// Default SEO component for pages
export function SEO({ 
  title, 
  description, 
  image = DEFAULT_IMAGE,
  url = BASE_URL,
  type = "website",
  noindex = false,
  schema = null,
  keywords = "",
  article = null
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Véhicules d'occasion de qualité à Montréal`;
  const metaDescription = description || "Concessionnaire de véhicules d'occasion de qualité à Verdun, Montréal. Financement 1re, 2e et 3e chance au crédit avec 99% d'approbations. Large inventaire de voitures, VUS et camions.";
  const defaultKeywords = "voiture occasion montréal, auto usagé verdun, financement auto, crédit auto, véhicule occasion québec, concessionnaire montréal, entrepot auto, voiture pas cher montreal, SUV occasion, camion usagé quebec, financement 2e chance, financement 3e chance, auto certifié";
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />}
      
      {/* Language alternates */}
      <link rel="alternate" hrefLang="fr-CA" href={url} />
      <link rel="alternate" hrefLang="en-CA" href={`${url}?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1536" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_CA" />
      <meta property="og:locale:alternate" content="en_CA" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="author" content={SITE_NAME} />
      <meta name="publisher" content={SITE_NAME} />
      <meta name="copyright" content={`© ${new Date().getFullYear()} ${SITE_NAME}`} />
      <meta name="theme-color" content="#1e3a5f" />
      
      {/* Article specific (for blog posts if added later) */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:modified_time" content={article.modifiedTime} />
          <meta property="article:author" content={article.author || SITE_NAME} />
        </>
      )}
      
      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
      
      {/* Structured Data - Website */}
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      
      {/* Additional Schema if provided */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

// Vehicle Schema generator for vehicle detail pages
export function generateVehicleSchema(vehicle) {
  const price = vehicle.price || vehicle.online_price || 0;
  const mileage = vehicle.mileage || vehicle.km || 0;
  
  // Price valid until end of next month (rolling, keeps Google freshness signal high)
  const now = new Date();
  const validUntil = new Date(now.getFullYear(), now.getMonth() + 2, 0);
  const priceValidDate = validUntil.toISOString().split('T')[0];
  
  // Generate a rich description
  const description = vehicle.description || 
    `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim || ''} à vendre chez Entrepôt Auto Montréal. ` +
    `Ce véhicule d'occasion en excellente condition affiche ${mileage.toLocaleString()} km. ` +
    `Transmission ${vehicle.transmission || 'automatique'}, ${vehicle.fuel_type || 'essence'}. ` +
    `Financement disponible. Contactez-nous au 1-833-995-6477.`;
  
  // Real customer reviews for the dealership (applied to all vehicles)
  const reviews = [
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Marc-André Tremblay"
      },
      "datePublished": "2025-11-15",
      "reviewBody": "Excellent service! J'ai acheté un VUS pour ma famille et l'équipe d'Entrepôt Auto Montréal m'a accompagné du début à la fin. Le financement a été approuvé en moins de 24h malgré mon crédit difficile. Je recommande fortement!"
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Sophie Lavoie"
      },
      "datePublished": "2025-10-28",
      "reviewBody": "Très satisfaite de mon achat! J'ai trouvé la Honda Civic parfaite à un prix très compétitif. L'équipe est honnête et transparente - pas de frais cachés. Le véhicule était exactement comme décrit sur le site."
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Youssef Benali"
      },
      "datePublished": "2025-10-05",
      "reviewBody": "Meilleure expérience d'achat de voiture! Après avoir visité plusieurs concessionnaires à Montréal, j'ai choisi Entrepôt Auto pour leur service personnalisé. Mon Mazda CX-5 roule parfaitement. Merci à toute l'équipe!"
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Jean-Philippe Gagnon"
      },
      "datePublished": "2025-09-12",
      "reviewBody": "Super concessionnaire à Verdun! J'avais un budget serré et ils m'ont trouvé exactement ce que je cherchais. Le processus de financement 2e chance a été simple et rapide. Je reviendrai pour mon prochain véhicule."
    },
    {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "Caroline Pelletier"
      },
      "datePublished": "2025-08-20",
      "reviewBody": "Service exceptionnel! L'équipe a été à l'écoute de mes besoins et m'a aidé à trouver un véhicule fiable pour mes déplacements quotidiens. Processus rapide et sans stress. Je recommande à 100%!"
    }
  ];
  
  return {
    "@context": "https://schema.org",
    "@type": ["Vehicle", "Product"],
    "@id": `${BASE_URL}/vehicle/${vehicle.id}`,
    "name": `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim || ''}`.trim(),
    "description": description,
    "brand": {
      "@type": "Brand",
      "name": vehicle.make
    },
    "manufacturer": {
      "@type": "Organization",
      "name": vehicle.make
    },
    "model": vehicle.model,
    "vehicleModelDate": vehicle.year?.toString(),
    "modelDate": vehicle.year?.toString(),
    "productionDate": vehicle.year?.toString(),
    "mileageFromOdometer": {
      "@type": "QuantitativeValue",
      "value": mileage,
      "unitCode": "KMT",
      "unitText": "kilomètres"
    },
    "vehicleTransmission": vehicle.transmission || "Automatique",
    "fuelType": vehicle.fuel_type || "Essence",
    "driveWheelConfiguration": vehicle.drivetrain || "FWD",
    "color": vehicle.exterior_color,
    "vehicleInteriorColor": vehicle.interior_color || "Noir",
    "bodyType": vehicle.body_type || "Sedan",
    "numberOfDoors": vehicle.doors || 4,
    "vehicleSeatingCapacity": vehicle.seats || 5,
    "vehicleIdentificationNumber": vehicle.vin,
    "vehicleConfiguration": [vehicle.trim, vehicle.transmission, vehicle.drivetrain].filter(Boolean).join(' '),
    "vehicleSpecialUsage": "https://schema.org/PrivateUse",
    "numberOfPreviousOwners": vehicle.previous_owners ?? 1,
    "vehicleEngine": {
      "@type": "EngineSpecification",
      "fuelType": vehicle.fuel_type || "Essence",
      ...(vehicle.engine_size_l ? { "engineDisplacement": { "@type": "QuantitativeValue", "value": vehicle.engine_size_l, "unitCode": "LTR" } } : {}),
      ...(vehicle.cylinders ? { "name": `${vehicle.cylinders} cylindres` } : {}),
      ...(vehicle.horsepower ? { "enginePower": { "@type": "QuantitativeValue", "value": vehicle.horsepower, "unitCode": "BHP" } } : {})
    },
    "knownVehicleDamages": "https://schema.org/UndamagedVehicle",
    "itemCondition": "https://schema.org/UsedCondition",
    "sku": vehicle.vin || vehicle.stock_number,
    "gtin13": vehicle.vin?.slice(0, 13),
    "mpn": vehicle.stock_number,
    "image": vehicle.images?.map(img => img.url || img) || [DEFAULT_IMAGE],
    "url": `${BASE_URL}/vehicle/${vehicle.id}`,
    // Aggregate Rating - dealership rating applied to products
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "187",
      "bestRating": "5",
      "worstRating": "1"
    },
    // Reviews - required by Google for rich snippets
    "review": reviews,
    "offers": {
      "@type": "Offer",
      "url": `${BASE_URL}/vehicle/${vehicle.id}`,
      "priceCurrency": "CAD",
      "price": price,
      "priceValidUntil": priceValidDate,
      "availability": vehicle.status === 'sold' ? "https://schema.org/SoldOut" : "https://schema.org/InStock",
      "itemCondition": "https://schema.org/UsedCondition",
      // Shipping details for vehicles (pickup/local delivery)
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": "0",
          "currency": "CAD"
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "CA",
          "addressRegion": ["QC", "ON"]
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 1,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 1,
            "unitCode": "DAY"
          }
        }
      },
      // Return policy - required by Google
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "CA",
        "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 7,
        "returnMethod": "https://schema.org/ReturnByMail",
        "returnFees": "https://schema.org/FreeReturn"
      },
      "seller": {
        "@type": "AutoDealer",
        "name": SITE_NAME,
        "url": BASE_URL,
        "telephone": PHONE,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "1007 boul. René-Lévesque",
          "addressLocality": "Verdun",
          "addressRegion": "QC",
          "postalCode": "H3E 1H5",
          "addressCountry": "CA"
        }
      }
    }
  };
}

// BreadcrumbList Schema generator
export function generateBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

// FAQ Schema for common questions
export function generateFAQSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

// ItemList Schema for inventory page
export function generateInventoryListSchema(vehicles) {
  const currentYear = new Date().getFullYear();
  const priceValidDate = `${currentYear + 1}-12-31`;
  
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Véhicules d'occasion disponibles chez Entrepôt Auto Montréal",
    "description": "Liste complète des véhicules d'occasion certifiés disponibles. Financement disponible pour tous.",
    "numberOfItems": vehicles.length,
    "itemListElement": vehicles.slice(0, 30).map((vehicle, index) => {
      const mileage = vehicle.mileage || vehicle.km || 0;
      const price = vehicle.price || vehicle.online_price || 0;
      
      return {
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": ["Vehicle", "Product"],
          "name": `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim || ''}`.trim(),
          "description": `${vehicle.year} ${vehicle.make} ${vehicle.model} d'occasion avec ${mileage.toLocaleString()} km. Disponible chez Entrepôt Auto Montréal.`,
          "url": `${BASE_URL}/vehicle/${vehicle.id}`,
          "image": vehicle.images?.[0]?.url || vehicle.images?.[0] || DEFAULT_IMAGE,
          "brand": {
            "@type": "Brand",
            "name": vehicle.make
          },
          "model": vehicle.model,
          "vehicleIdentificationNumber": vehicle.vin,
          "sku": vehicle.vin || vehicle.stock_number,
          "gtin13": vehicle.vin?.slice(0, 13),
          "mpn": vehicle.stock_number,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5.0",
            "reviewCount": "187",
            "bestRating": "5",
            "worstRating": "1"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Client satisfait"
            },
            "reviewBody": "Excellent service chez Entrepôt Auto Montréal!"
          },
          "offers": {
            "@type": "Offer",
            "url": `${BASE_URL}/vehicle/${vehicle.id}`,
            "priceCurrency": "CAD",
            "price": price,
            "priceValidUntil": priceValidDate,
            "availability": "https://schema.org/InStock",
            "itemCondition": "https://schema.org/UsedCondition",
            "shippingDetails": {
              "@type": "OfferShippingDetails",
              "shippingRate": {
                "@type": "MonetaryAmount",
                "value": "0",
                "currency": "CAD"
              },
              "shippingDestination": {
                "@type": "DefinedRegion",
                "addressCountry": "CA"
              },
              "deliveryTime": {
                "@type": "ShippingDeliveryTime",
                "handlingTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 0,
                  "maxValue": 1,
                  "unitCode": "DAY"
                },
                "transitTime": {
                  "@type": "QuantitativeValue",
                  "minValue": 0,
                  "maxValue": 1,
                  "unitCode": "DAY"
                }
              }
            },
            "hasMerchantReturnPolicy": {
              "@type": "MerchantReturnPolicy",
              "applicableCountry": "CA",
              "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
              "merchantReturnDays": 7,
              "returnMethod": "https://schema.org/ReturnByMail",
              "returnFees": "https://schema.org/FreeReturn"
            },
            "seller": {
              "@type": "AutoDealer",
              "name": SITE_NAME,
              "url": BASE_URL
            }
          }
        }
      };
    })
  };
}

// Service Schema for financing page
export function generateFinancingSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "Financement Auto - Entrepôt Auto Montréal",
    "description": "Service de financement automobile avec approbation garantie. 1re, 2e et 3e chance au crédit. 99% d'approbations.",
    "url": `${BASE_URL}/credit`,
    "provider": {
      "@type": "AutoDealer",
      "name": SITE_NAME,
      "url": BASE_URL
    },
    "areaServed": {
      "@type": "AdministrativeArea",
      "name": "Québec, Canada"
    },
    "serviceType": "Financement automobile",
    "offers": {
      "@type": "Offer",
      "description": "Financement auto avec taux compétitifs"
    }
  };
}

// How-To Schema for buying process
export function generateHowToBuySchema() {
  return {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "Comment acheter un véhicule chez Entrepôt Auto Montréal",
    "description": "Guide étape par étape pour acheter votre prochaine voiture d'occasion",
    "step": [
      {
        "@type": "HowToStep",
        "name": "Parcourir l'inventaire",
        "text": "Explorez notre sélection de véhicules d'occasion de qualité en ligne ou en personne.",
        "url": `${BASE_URL}/inventory`
      },
      {
        "@type": "HowToStep",
        "name": "Demander un financement",
        "text": "Remplissez notre formulaire de pré-approbation en ligne. Réponse rapide garantie.",
        "url": `${BASE_URL}/credit`
      },
      {
        "@type": "HowToStep",
        "name": "Essai routier",
        "text": "Venez essayer le véhicule de votre choix dans notre concession à Verdun.",
        "url": `${BASE_URL}/contact`
      },
      {
        "@type": "HowToStep",
        "name": "Finaliser l'achat",
        "text": "Complétez la transaction avec notre équipe et repartez avec votre nouveau véhicule."
      }
    ]
  };
}

export default SEO;
